import { render, staticRenderFns } from "./KardexValued.vue?vue&type=template&id=3a84b912&"
import script from "./KardexValued.vue?vue&type=script&lang=js&"
export * from "./KardexValued.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports